<template>
  <div class="collapse">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['autoReply'],
      }"
      @click="configMainShow['autoReply'] = !configMainShow['autoReply']"
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>智能答复</span>
        <span
          class="el-switch"
          @click.stop="toggleEnable('autoReply', '智能答复')"
        >
          <el-switch v-model="configure.autoReply.enable" disabled></el-switch>
        </span>
      </div>
    </div>
    <div
      class="bd"
      @click="
        isNaN(featureList['autoReply'].timeRemaining)
          ? shoWDialogBuy(
              featureList['autoReply']['productKey'],
              '基础包',
              'autoReply'
            )
          : featureList['autoReply'].timeRemaining <= 0
          ? showFunctionalRenewal(true)
          : configure.autoReply.enable
          ? ''
          : toggleEnable('autoReply', '智能答复')
      "
      :class="{
        'no-buy': isNaN(featureList['autoReply'].timeRemaining),
        expired: featureList['autoReply'].timeRemaining <= 0,
        'shut-off': !configure.autoReply.enable,
      }"
    >
      <el-row>
        <el-col :span="5">
          关键词
          <br />与答复
        </el-col>
        <el-col :span="19">
          <div class="block-tag article">
            虎牙违禁词，如“QQ群”之类，会发不出来。详见「<a
              href="//www.xiaohudi.com/entry/1.html"
              target="_blank"
              >虎牙吞字</a
            >」
          </div>
          <div class="sentence-list" ref="list">
            <ul
              v-if="configure.autoReply.msg && configure.autoReply.msg.length"
            >
              <li v-for="(item, index) in configure.autoReply.msg" :key="index">
                <div class="tag-editor">
                  <div
                    class="tag-editor-row"
                    :class="{
                      or: item.isOr,
                      and: !item.isOr,
                    }"
                  >
                    <span class="hd">关键词：</span>
                    <el-tag
                      v-for="(ii, idx) in item.keywords"
                      :key="idx"
                      size="small"
                      closable
                      @close="removeTagMsg(item.keywords, idx)"
                      >{{ ii }}</el-tag
                    >
                    <input
                      type="text"
                      placeholder="输入完，按回车确认"
                      @blur="addTagMsg(item.keywords, $event)"
                      @keyup.enter="addTagMsg(item.keywords, $event)"
                    />
                  </div>
                  <div class="tag-editor-row">
                    <span class="hd">答　复：</span>
                    <input
                      type="text"
                      :ref="index == 0 ? 'msgInput' : ''"
                      @blur="watchMsgChangefunction"
                      v-model="item.tpl"
                    />
                  </div>
                </div>
                <i
                  class="fa-window-close"
                  @click="removeAutoReplyMsg(index)"
                ></i>
              </li>
            </ul>
          </div>
          <div
            class="sentence-add"
            tabindex="99"
            @focusin="eleFocusIn('addautoReplyMsgTpl')"
            @focusout="autoReplyMsgFocusOut"
          >
            <div class="tag-editor">
              <div
                class="tag-editor-row"
                :class="{
                  or: addautoReplyMsg.isOr,
                  and: !addautoReplyMsg.isOr,
                }"
              >
                <span class="hd">关键词：</span>
                <el-tag
                  v-for="(item, index) in addautoReplyMsg.keywords"
                  :key="index"
                  size="small"
                  closable
                  @close="removeTag(addautoReplyMsg.keywords, index)"
                  >{{ item }}</el-tag
                >
                <input
                  type="text"
                  placeholder="输入完，按回车确认"
                  @blur="addTag(addautoReplyMsg.keywords, $event)"
                  @keyup.enter="addTag(addautoReplyMsg.keywords, $event)"
                />
              </div>
              <div class="tag-editor-row">
                <span class="hd">答　复：</span>
                <input type="text" v-model.trim="addautoReplyMsg.tpl" />
              </div>
              <el-dropdown
                class="words-relation"
                @command="isOrChange"
                trigger="click"
              >
                <span class="el-dropdown-link">
                  {{ addautoReplyMsg.isOr ? '"或" 关系' : '"且" 关系' }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ value: true }"
                    >"或" 关系</el-dropdown-item
                  >
                  <el-dropdown-item :command="{ value: false }"
                    >"且" 关系</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <el-popover
              ref="addautoReplyMsgTpl"
              placement="bottom-end"
              width="280"
              v-model="isShowInputBlurTips.addautoReplyMsgTpl"
              trigger="manual"
              :popper-options="{
                boundariesElement: 'body',
                adaptive: false,
              }"
            >
              <p>记得点“添加句子”才会生效哦</p>
            </el-popover>
            <el-button
              size="small"
              @click="addautoReplyMsgTpl"
              v-popover:addautoReplyMsgTpl
              >添加句子</el-button
            >
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row>
        <el-col :span="5">防调戏</el-col>
        <el-col :span="19">
          同一关键词，
          <el-input-number
            v-model="configure.autoReply.replayRepeat"
            :controls-position="isPC ? 'right' : ''"
            :min="0"
            :max="60"
            size="mini"
            :precision="1"
          ></el-input-number
          >分钟内不再答复。
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">授权用户</el-col>
        <el-col :span="19">
          <div>
            <el-checkbox
              v-model="configure.autoReply.fansBadgeEnable"
            ></el-checkbox>
            <span
              @click="
                configure.autoReply.fansBadgeEnable =
                  !configure.autoReply.fansBadgeEnable
              "
            >
              粉丝牌等级≥
              <el-input-number
                @click.stop.native
                v-model="configure.autoReply.fansBadgeLevel"
                :controls-position="isPC ? 'right' : ''"
                :min="0"
                size="mini"
              ></el-input-number
              >级的用户才能触发智能答复。</span
            >
          </div>
          <div class="row-padding">
            <el-checkbox
              v-model="configure.autoReply.nobleLevelEnable"
            ></el-checkbox>
            <span
              @click="
                configure.autoReply.nobleLevelEnable =
                  !configure.autoReply.nobleLevelEnable
              "
            >
              贵族等级≥
              <el-select
                v-model="configure.autoReply.nobleLevel"
                placeholder="请选择"
                size="mini"
              >
                <el-option
                  v-for="item in welcomeConfig"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option> </el-select
              >的用户才能触发智能答复。</span
            >
          </div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row v-if="false">
        <el-col :span="5"> 世界杯 </el-col>
        <el-col :span="19">
          <div>
            <div style="padding-top: 5px; margin-bottom: 10px">
              <el-switch
                v-model="configure.autoReply.football.pushEnable"
              ></el-switch>
              赛事推送
            </div>
            <div class="block-tag article">
              开启后，小虎弟将实时推送当日比赛情况
            </div>
          </div>
          <div class="row-padding">
            <div style="padding-top: 5px; margin-bottom: 10px">
              <el-switch
                v-model="configure.autoReply.football.codeEnable"
              ></el-switch>
              赛事查询
            </div>
            <div class="block-tag article">
              开启后，观众输入关键词可获取相关信息
            </div>
            <div class="block-tag article">
              <!-- 如果要查询所有可用指令，可以直接发送<span class="green"
                >@世界杯</span
              >,会自动答复所有可用指令 -->
              <div>指令如下:</div>
              <div><span class="green">@世界杯今日赛程</span></div>
              <div><span class="green">@世界杯实时赛况</span></div>
              <div>
                <span class="green"
                  >@世界杯<span class="country"></span>小组排名</span
                >
              </div>
              <div>
                <span class="green"
                  >@世界杯<span class="country"></span>场次</span
                >
              </div>
              <div>
                <span class="green"
                  >@世界杯<span class="country"></span>胜负平</span
                >
              </div>
              <div>
                <span class="green"
                  >@世界杯<span class="country"></span>进失球</span
                >
              </div>
              <div>
                <span class="green"
                  >@世界杯<span class="country"></span>净胜球</span
                >
              </div>
              <div>
                <span class="green"
                  >@世界杯<span class="country"></span>积分</span
                >
              </div>
              <div>
                <span class="green"
                  >@世界杯<span class="group"></span>排名</span
                >
              </div>
              <div>
                <span class="green"
                  >@世界杯<span class="group"></span>积分</span
                >
              </div>
              <!-- <div><span class="green">@世界杯总排名</span></div> -->
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('智能答复', 'autoReply')"
          >「智能答复」恢复默认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { configCommon } from "@/mixins/configCommon";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {
      //欢迎设定配置项
      welcomeConfig: require("@/assets/js/welcomeConfig.json"),
      addautoReplyMsg: { keywords: [], tpl: "", isOr: true },
      copyAutoReplyMsg: "",
    };
  },
  props: {
    configure: {
      type: Object,
      default: null,
    },
    featureList: {
      type: Object,
      default: null,
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          duty: true,
          global: true,
        };
      },
    },
  },
  watch: {},
  mounted() {
    this.copyAutoReplyMsg = this.configure.autoReply.msg.map((val) => {
      return JSON.stringify(val);
    });
  },
  methods: {
    removeAutoReplyMsg(index) {
      this.configure.autoReply.msg.splice(index, 1);
      this.$message.success("删除成功");
    }, // 删除智能答复语句

    addautoReplyMsgTpl() {
      if (this.addautoReplyMsg.keywords.length === 0) {
        this.$message.warning("关键词不能为空哦");
      } else if (this.addautoReplyMsg.tpl == "") {
        this.$message.warning("答复语句不能为空");
      } else {
        this.configure.autoReply.msg.unshift(this.addautoReplyMsg);
        this.addautoReplyMsg = { keywords: [], tpl: "", isOr: true };
      }
    }, // 智能答复添加
    isOrChange(data) {
      if (typeof data.index == "number") {
        this.configure.autoReply.msg[data.index].isOr = data.value;
        this.$forceUpdate();
      } else {
        this.addautoReplyMsg.isOr = data.value;
      }
    },
    autoReplyMsgFocusOut() {
      setTimeout(() => {
        if (
          this.addautoReplyMsg.keywords.length &&
          this.addautoReplyMsg.tpl.length
        ) {
          this.eleFocusOut("addautoReplyMsgTpl");
        }
      }, 2e3);
    },
    removeTagMsg(keywords, index) {
      this.removeTag(keywords, index);
      this.watchMsgChangefunction();
    },
    addTagMsg(keywords, event) {
      this.addTag(keywords, event);
      this.watchMsgChangefunction();
    },
    watchMsgChangefunction() {
      let newMsg = this.configure.autoReply.msg.map((n) => {
        return JSON.stringify(n);
      });
      if (newMsg.length != this.copyAutoReplyMsg.length) {
        this.copyAutoReplyMsg = this.configure.autoReply.msg.map((n) => {
          return JSON.stringify(n);
        });
        return;
      }
      let cIndex = newMsg.findIndex((c, i) => {
        return this.copyAutoReplyMsg[i] != c;
      });
      if (cIndex != -1) {
        this.configure.autoReply.msg.unshift(
          this.configure.autoReply.msg.splice(cIndex, 1)[0]
        );
        this.copyAutoReplyMsg = this.configure.autoReply.msg.map((n) => {
          return JSON.stringify(n);
        });
        setTimeout(() => {
          this.$refs.list.scrollTop = 0;
          this.$refs.msgInput[0].focus();
        }, 0);
      }
    },
  },
};
</script>
<style scoped>
.country::before {
  content: "国家";
  display: inline-block;
  padding: 0px 4px;
  border: 1px solid #649dd6;
  border-radius: 3px;
  font-size: 12px;
  line-height: 14px;
  position: relative;
  margin: 0 4px;
  color: #409eff;
  background: #ecf5ff;
}
.group::before {
  content: "组名";
  display: inline-block;
  padding: 0px 4px;
  border: 1px solid #649dd6;
  border-radius: 3px;
  font-size: 12px;
  line-height: 14px;
  position: relative;
  margin: 0 4px;
  color: #409eff;
  background: #ecf5ff;
}
</style>